import { NGOBusinessTypeEnum } from '../enum/ngo-business-type.enum';
import { NGODocumentAccessTypeEnum } from '../enum/ngo-document-access-type.enum';

export class NgoModel {
  name: string = null;
  address: string = null;
  reg_no: number = null;
  website: string = null;
  districts: string[] = null;
  country: string = null;
  business_type: NGOBusinessTypeEnum = null;
  phone: string = null;
  email: string = null;
  no_of_employees: number = null;
  founding_year: string = null;
  our_story: string = null;
  mission_vision: string = null;
  key_activities: string = null;
  logo_url: string = null;
  ngo_profile_img_caption: string = null;
  ngo_profile_img_url: string = null;
  ngo_document_url: string = null;
  admin_nid_url: string = null;
  updated_at: string = null;
  contact_name: string = null;
  contact_phone: string = null;
  socials: string = null;
  other_documents_url: string = null;
  other_documents_access: NGODocumentAccessTypeEnum = null;
  award_img_url: string = null;
  award_img_caption: string = null;
  ngo_sdg: string = null;
  cause_area: string = null;
  tags: string = null;
  work_area_geo_location: string = null;
  our_values: string = null;
  mission: string = null;
  vision: string = null;
  is_verified: string = null;
  ngo_profile_id: string = null;
  cover_img_url: string = null;
  
  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}
